module.exports = __webpack_public_path__ + "static/visionar_augemented_reality_top5_augmented_reality_trends_in_2020-4496df515cf11e5752e1c3eba8ed67ad.jpg";